// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const { getContentFormContainer } =
  require("../../manage/methods/ContentFormUtils").default
const { EMBED, LISTED, UPLOAD } = require("./ManageAudioConfig").default

export const upload = {
  icon: "arrow-up-circle",
  title: "Upload an audio file",
  prompt: "An mp3 file from your computer",
  form: getContentFormContainer(UPLOAD)
}
export const embed = {
  icon: "file-audio",
  title: "Embed an audio file",
  prompt: "From Soundcloud, YouTube,...",
  form: getContentFormContainer(EMBED)
}
export const listed = {
  icon: "share",
  title: "Reference a recording",
  prompt: "From a CD, music service, radio, podcast,...",
  form: getContentFormContainer(LISTED)
}
